import { FeatureFlagServiceApiVersion } from './types';
export const CURRENT_FFS_API_VERSION = FeatureFlagServiceApiVersion.V2;